import { getLang } from '../lang';
import de from './labels-de.json';
import en from './labels-en.json';
import pt from './labels-pt.json';
import es from './labels-es.json';

const langLabels = {
  de,
  en,
  pt,
  es,
};

const numbers = {
  de: singularPluralNumber,
  en: singularPluralNumber,
  pt: singularPluralNumber,
  es: singularPluralNumber,
};

export const Labels = {
  PageTitle: new Label('page_title'),
  Footer: new Label('footer'),
  PlayNow: new Label('play_now'),
  CookieTitle: new Label('cookie_title'),
  CookieText: new Label('cookie_text'),
  CookieLearnMore: new Label('cookie_learn_more'),
  CookieAccept: new Label('cookie_accept'),
  PrivacyPolicy: new Label('privacy_policy'),
  TermsOfService: new Label('terms_of_service'),
};

function Label(key) {
  this.key = key;

  this.getValue = (args = undefined, countBy = undefined) => {
    const lang = getLang();
    var actualKey = key;

    if (countBy !== undefined) {
      actualKey = key + '.' + numbers[lang](countBy);
    }

    var label = langLabels[lang][actualKey] || actualKey;

    if (args) {
      Object.entries(args).forEach(
        ([key, value]) => label = label.replaceAll(`\$\{${key}\}`, value));
    }

    return label;
  };
}

function singularPluralNumber(count) {
  if (count === 1) {
    return 'singular';
  }

  return 'plural';
}